<template>
    <div v-if="showModal && payment">
        test
        <b-modal
            v-model="showModalLocal"
            :title="'Привязка броней (счетов)  к платежу'"
            class="modal-primary"
            size="lg"
            ok-variant="primary"
            @hide.prevent
            @ok="handleOk"
            @cancel="handleCancel"
            @close="handleCancel"
            ref="my-modal"
        >

            <h1>{{ getPaymentTypeName(payment.type) }} #{{payment.id}}</h1>

            <b-row>
                <b-col class="col-md-6">
                    <strong>Сумма платежа</strong>: {{ formatPriceKop(payment.amount) }}
                </b-col>
                <b-col class="col-md-6" v-if="payment.contractor">
                    <strong>Контрагент</strong>: {{ payment.contractor.title }} #{{ payment.contractor.id }}
                </b-col>
                <b-col class="col-md-6" v-if="payment.client">
                    <strong>Клиент</strong>: {{ payment.client.title }} #{{ payment.client.id }}
                </b-col>
                <b-col class="col-md-6" v-if="payment.uuid1c">
                    <strong>1C UUID</strong>: {{ payment.uuid1c }}
                </b-col>
                <b-col class="col-md-6" v-if="payment.document_number">
                    <strong>Платежное поручение</strong>: {{ payment.document_number }} от {{ printDate(payment.document_date) }}
                </b-col>
                <b-col class="col-md-6" v-if="payment.statement_number">
                    <strong>Выписка</strong>: {{ payment.statement_number }} от {{ printDate(payment.statement_date) }}
                </b-col>
                <b-col class="col-md-6" v-if="payment.invoice_number">
                    <strong>Счет</strong>: {{ payment.invoice_number }} от {{ printDate(payment.invoice_date) }}
                </b-col>
                <b-col class="col-md-6">
                    <strong>Плательщик</strong>: {{ payment.payer_inn }}<template v-if="payment.payer_kpp">/{{ payment.payer_kpp }}</template>
                </b-col>
                <b-col class="col-md-6">
                    <strong>Получатель</strong>: {{ payment.payee_inn }}<template v-if="payment.payee_kpp">/{{ payment.payee_kpp }}</template>
                </b-col>
                <b-col class="col-md-6" v-if="payment.voucher_info">
                    <strong>Путевка</strong>: {{ payment.voucher_info }}
                </b-col>
                <b-col class="col-md-6" v-if="payment.booking_info">
                    <strong>Бронь(и)</strong>: <a :href="$router.resolve({ path:bookingPage(payment.booking_info)}).href">{{ payment.booking_info }}</a><br>
                </b-col>
                <b-col class="col-md-6" v-if="payment.contract">
                    <strong>Договор</strong>: {{ payment.contract }}
                </b-col>
                <b-col class="col-md-6" v-if="payment.finance_id">
                    <strong>Проводка</strong>: {{ payment.finance_id }}
                </b-col>
                <b-col class="col-md-6" v-else>
                    <strong class="text-danger">Не проведено</strong>
                </b-col>
                <b-col class="col-md-12" v-if="payment.contract">
                    <strong>Назначение платежа</strong>: {{ payment.info }}
                </b-col>
            </b-row>

            <template v-if="isPaymentToObject(payment.type)">
                <table class="table table-bordered table-sm table-hover">
                    <tr>
                        <th>
                            Бронь<br>
                            <small><br>статус</small>
                        </th>
                        <th>
                            Разнесенная сумма
                            <small><br>(по данному платежу)</small>
                        </th>
                        <th>
                            Сумма к оплате<br>
                        </th>
                        <th>
                            Неразнесенный остаток
                            <small><br>(по брони)</small>
                        </th>
                        <th>
                            Поставщик<br>
                            Счет
                        </th>
                        <th>
                            <i class="fa fa-times fa-lg text-black-50"></i>
                        </th>

                    </tr>
                    <tr v-for="br in payment.booking_relatons" :key="br.id">
                        <td>
                            <a :href="$router.resolve({ path:bookingPage(br.booking.id)}).href">{{ br.booking.id }}</a><br>
                            <small>{{ getBookingStatusName(br.booking.status) }}</small>
                        </td>
                        <td>
                            {{ formatPriceKop(br.value) }}
                            <template v-if="br.manual"><small><br>разнесено вручную</small></template>
                        </td>
                        <td>
                            {{ formatPriceKop(br.booking.to_pay_value) }}
                        </td>
                        <td>
                            {{ formatPriceKop(br.booking.to_pay_value-br.booking.binded_amount) }}
                        </td>
                        <td>
                            <template v-if="br.booking.supplier">
                                {{ br.booking.supplier.title }} #{{ br.booking.supplier_id }}<br>
                                Счет № {{ br.booking.invoice_number }} от {{ printDate(br.booking.invoice_date) }} на {{ formatPriceKop(br.booking.invoice_value) }}
                            </template>
                        </td>
                        <td>
                            <a href="#" @click.prevent="doUnbind(br)">
                                <i class="fa fa-times fa-lg text-danger"></i>
                            </a>
                        </td>
                    </tr>

                    <tr>
                        <th>
                            Итого
                        </th>
                        <th>
                            {{  formatPriceKop(total_binded) }}
                        </th>

                    </tr>
                    <tr>
                        <th>
                            Не разнесено
                        </th>
                        <th>
                            {{  formatPriceKop(to_be_binded) }}
                        </th>

                    </tr>

                </table>

                <template v-if="to_be_binded>0">
                    <h3>Привязка платежа к брони</h3>

                    <b-form-group
                        label="Бронь"
                    >
                        <select name="123" class="form-control" v-model="to_bind_booking" @input="onInputToBindBooking">
                            <option v-for="booking in bookings" :key="booking.id" :value="booking">
                                Бронь #{{booking.id}} (счет № {{ booking.invoice_number }} от {{ printDate(booking.invoice_date) }} на {{ formatPriceKop(booking.invoice_value) }})
                            </option>
                        </select>
                    </b-form-group>

                    <b-form-group
                        label="Сумма платежа разносимая на бронь"
                        description="Укажите сумму платежа, которая должна быть отнесена к брони. Сумма не дожна превышать неразнесенный остаток платежа и сумму 'к оплате'"
                    >
                        <input class="form-control" v-model.number="_to_bind_value">
                    </b-form-group>

                    <button class="btn btn-primary" @click="doBind">Привязать</button>
                </template>
            </template>



            <!--{ "company_id": 50, "operator_id": 540, }-->
            <!-- {{ paymentx }}-->

            <template slot="modal-footer" slot-scope="{ ok, cancel, close }">
                <b-button size="sm" variant="outline-secondary" @click="cancel()">
                    Закрыть
                </b-button>
<!--                <b-button size="sm" variant="outline-success" @click="ok()">-->
<!--                    Сохранить-->
<!--                </b-button>-->
            </template>
        </b-modal>
    </div>
</template>


<script>
    import {CONSTANTS} from '@/constants';
    import { functions } from '@/functions.js';
    import { functions_payments } from '@/functions/payments.js';
    import { functions_booking } from '@/functions/booking.js';

    export default {
        name: 'BindPaymentDialog',
        mixins: [functions, functions_payments, functions_booking],
        data: function () {
            return {
                to_bind_booking:null,
                to_bind_value:0,
            };
        },
        model: {
            prop: "showModal",
            event: "hide"
        },
        props: {
            showModal: [Number, Boolean],
            paymentx: Object,
        },
        methods: {
            handleCancel: function () {
                //console.log('BindPaymentDialog: handleCancel');
                this.$emit("hide", false);
            },
            handleOk: function () {
                //console.log('BindPaymentDialog: handleOk');
                this.$emit("hide", false);
            },
            handleSubmit: function () {
                //console.log('BindPaymentDialog: handleSubmit');
                this.$emit("hide", false);
            },
            doUnbind: function (br) {
                console.log('doUnbind', this.payment.id, br.booking_id, br.id);
                this.unbindBookingToPayment(this.payment.id, br.booking_id, br.id, function (self) {
                    console.log('unbindBookingToPayment success contractor_id='+self.paymentx.contractor_id)
                    self.loadBookingsForCompany(self.paymentx.contractor_id);
                }, this);
            },
            doBind: function () {
                console.log('doBind', this.to_bind_booking.id, this.to_bind_value);
                this.bindBookingToPayment(this.payment.id, this.to_bind_booking.id, this.to_bind_value, function (self) {
                    console.log('bindBookingToPayment success contractor_id='+self.paymentx.contractor_id)
                    self.loadBookingsForCompany(self.paymentx.contractor_id);
                }, this);
            },
            onInputToBindBooking:function () {


            },
            isPaymentToObject: function(type) {
                return type == CONSTANTS.PAYMENT_TYPE_OBJECT;
            }
        },
        computed: {
            showModalLocal: {
                get: function () {
                    return this.showModal
                },
                set: function (newValue) {}
            },
            total_binded: function () {
                return this.payment.binded_amount;
            },
            to_be_binded: function () {
                return this.payment.amount - this.total_binded;
            },
            _to_bind_value: {
                set: function (val) {
                    this.to_bind_value = Math.round(val * 100);
                },
                get: function () {
                    return this.to_bind_value / 100;
                }
            },
        },
        watch:{
            to_bind_booking: function () {
                console.log('onInputToBindBooking 1');
                this.to_bind_value = this.to_be_binded;
                let x = 0;
                if (this.to_bind_booking) {

                    console.log('onInputToBindBooking 2 this.to_bind_booking', this.to_bind_booking);
                    console.log('onInputToBindBooking 3 this.to_bind_booking.to_pay_value', this.to_bind_booking.to_pay_value);
                    console.log('onInputToBindBooking 4 this.to_bind_booking.binded_amount', this.to_bind_booking.binded_amount);
                    x = this.to_bind_booking.to_pay_value - this.to_bind_booking.binded_amount;
                }
                console.log('onInputToBindBooking 5 x', x);
                if (x<this.to_bind_value) {
                    this.to_bind_value = x;
                }
            }
        },
        created: function() {
            console.log('loadPayment')
            this.loadPayment(this.paymentx.id);

            console.log('loadBookingsForCompany->')
            this.loadBookingsForCompany(this.paymentx.contractor_id)

            //console.log('BindPaymentDialog: created');
        },
        mounted: function() {
            //console.log('BindPaymentDialog: mounted');
        },
        updated: function() {
            //console.log('BindPaymentDialog: updated');
        },
    }
</script>
